import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateTwoPDFSectionWithSubsections } from "./common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeWorkExperience } from "lib/redux/types";

export const Experience = ({
  heading,
  workExperiences,
  themeColor,
}: {
  heading: string;
  workExperiences: ResumeWorkExperience[];
  themeColor: string;
}) => {
  return (
    <TemplateTwoPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {workExperiences.map(
        ({ company, jobTitle, startDate, endDate, descriptions }, idx) => {
          // Hide company name if it is the same as the previous company
          const hideCompanyName =
            idx > 0 && company === workExperiences[idx - 1].company;

          return (
            <View
              key={idx}
              style={{
                ...styles.flexRow,
                ...(idx !== 0 ? { marginTop: "6pt" } : {}), // Reduced from spacing["2"] (24pt) to 6pt
              }}
              wrap={false}
            >
              <View style={{ width: "30%" }}>
                <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <View style={{ width: "70%" }}>
                {!hideCompanyName && (
                  <ResumePDFText bold={true} style={{ lineHeight: "1.2" }}>
                    {company}
                  </ResumePDFText>
                )}
                <View
                  style={{
                    ...styles.flexRowBetween,
                    marginTop: hideCompanyName
                      ? "-3pt" // Reduced from spacing["1"] (12pt) to 3pt
                      : "4pt", // Reduced from spacing["1.5"] (18pt) to 4pt
                  }}
                >
                  <ResumePDFText style={{ lineHeight: "1.2" }}>
                    {jobTitle}
                  </ResumePDFText>
                </View>
                <View style={{ ...styles.flexCol, marginTop: "3pt" }}> {/* Reduced from spacing["1.5"] (18pt) to 3pt */}
                  <ResumePDFDescription items={descriptions} />
                </View>
              </View>
            </View>
          );
        }
      )}
    </TemplateTwoPDFSectionWithSubsections>
  );
};
